
  document.addEventListener("DOMContentLoaded", function () {
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function setCookie(name, value, days) {
    const date = new Date();
    date.setDate(date.getDate() + days);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  const cookieName = "sc-promotions-bar";
  const cookieValue = getCookie(cookieName);

  if (!cookieValue || cookieValue === "false") {
    document.getElementById("promotions-bar").classList.remove("is-hidden");
    document.getElementById("promotions-bar").classList.add("is-visible");
  }
  document
    .getElementById("promotions-bar-close")
    .addEventListener("click", function () {
      setCookie(cookieName, "true", 7);
      const promotionsBar = document.getElementById("promotions-bar");
      promotionsBar.classList.remove("is-visible");
      promotionsBar.classList.add("is-hidden");
    });
});






